import React, { useMemo } from 'react';

import * as CONCEPT from 'scenes/Gallery/GalleryPage/Concepts/constants';
import { useConcept } from 'scenes/Gallery/GalleryPage/Concepts/data';
import * as CONCEPT_VIEW from 'scenes/Gallery/GalleryPage/Concepts/view-constants';
import * as CREATIVE from 'scenes/Gallery/GalleryPage/Creatives/constants';
import {
  useCreativeDetails,
  useCreative,
} from 'scenes/Gallery/GalleryPage/Creatives/data';
import { useMoveTo } from 'scenes/Gallery/GalleryPage/Creatives/data/mutations/useMoveTo';
import { CREATIVE_ID } from 'scenes/Gallery/GalleryPage/constants';

import MoveToForm from './MoveToForm';
import { validationSchema } from './schemas';

const MoveToFormWrapper = ({
  id,
  onSubmit,
  onClose,
  onAddConcept,
  open,
  onExited,
}) => {
  const { data: creative, isLoading: creativeIsLoading } = useCreative({ id });

  const { data: creativeDetails, isLoading: isLoadingCreativeDetails } =
    useCreativeDetails({ id });

  const { data: concept, isLoading: isLoadingConcept } = useConcept(
    {
      id: creative?.[CREATIVE.CONCEPT_ID],
    },
    {
      enabled: !!creative?.[CREATIVE.CONCEPT_ID],
    }
  );
  const [moveCreative] = useMoveTo();
  const handleSubmit = async (values) => {
    await moveCreative(values);
    onSubmit();
  };

  const initialValues = useMemo(() => {
    if (!creative || !concept || !creativeDetails) {
      return;
    }
    return {
      [CREATIVE_ID]: id,
      [CONCEPT_VIEW.APPLICATIONS]: creative?.[CREATIVE.APPLICATION]
        ? [creative?.[CREATIVE.APPLICATION]]
        : concept?.[CONCEPT.APPLICATIONS],
    };
  }, [id, creative, concept, creativeDetails]);

  return (
    <MoveToForm
      loading={
        creativeIsLoading || isLoadingConcept || isLoadingCreativeDetails
      }
      entityId={id}
      onClose={onClose}
      active={!!initialValues}
      creative={creativeDetails}
      initialValues={initialValues}
      validationSchema={validationSchema}
      onAddConcept={onAddConcept}
      onSubmit={handleSubmit}
      onExited={onExited}
      open={open}
    />
  );
};

export default MoveToFormWrapper;
